var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "d-flex flex-nowrap" },
    [
      _c(
        "v-tooltip",
        {
          attrs: { bottom: "" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function({ on }) {
                return [
                  _c(
                    "v-btn",
                    _vm._g(
                      {
                        attrs: {
                          small: "",
                          icon: "",
                          disabled: _vm.value === 1
                        },
                        on: { click: _vm.firstPage }
                      },
                      on
                    ),
                    [_c("v-icon", [_vm._v("first_page")])],
                    1
                  )
                ]
              }
            }
          ])
        },
        [
          _vm._v(" "),
          _c("span", { staticClass: "ma-1" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.generateMessage("boilerplate.first_page")) +
                "\n    "
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "v-tooltip",
        {
          attrs: { bottom: "" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function({ on }) {
                return [
                  _c(
                    "v-btn",
                    _vm._g(
                      {
                        attrs: {
                          small: "",
                          icon: "",
                          disabled: _vm.value === 1
                        },
                        on: { click: _vm.previousPage }
                      },
                      on
                    ),
                    [_c("v-icon", [_vm._v("chevron_left")])],
                    1
                  )
                ]
              }
            }
          ])
        },
        [
          _vm._v(" "),
          _c("span", { staticClass: "ma-1" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.generateMessage("boilerplate.previous_page")) +
                "\n    "
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "v-tooltip",
        {
          attrs: { bottom: "" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function({ on }) {
                return [
                  _c(
                    "v-btn",
                    _vm._g(
                      {
                        attrs: {
                          small: "",
                          disabled: _vm.disableNext,
                          icon: ""
                        },
                        on: { click: _vm.nextPage }
                      },
                      on
                    ),
                    [_c("v-icon", [_vm._v("chevron_right")])],
                    1
                  )
                ]
              }
            }
          ])
        },
        [
          _vm._v(" "),
          _c("span", { staticClass: "ma-1" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.generateMessage("boilerplate.next_page")) +
                "\n    "
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }